export default "__VITE_ASSET__aL0rAWuN__"